import { CHAIN_DATA, ETHW } from "../data/metaData";
import { COINGECKO_API } from "../data/constants";

export const fetchTokenQuotes = async (tokenID) => {
    const url = `${COINGECKO_API}/coins/${tokenID}`;

    const response = await fetch(url);

    const data = await response.json();
    const {
        current_price,
        market_cap,
        market_cap_rank,
        price_change_24h,
        price_change_percentage_24h,
        total_volume,
    } = data.market_data;

    const results =  {
        market_cap: market_cap.usd,
        market_cap_rank,
        price: current_price.usd,
        price_change_24h: Math.round(price_change_24h * 100) / 100,
        price_change_percentage_24h: Math.round(price_change_percentage_24h * 100) / 100,
        total_volume: total_volume.usd,
        coingecko_rank: data.coingecko_rank,
        tokenID,
    };
    if (!results.market_cap && tokenID === CHAIN_DATA[ETHW].coingeckoTokenId) {
        // Calculate ETHW market cap from Ethereum
        const ethResponse = await fetch(`${COINGECKO_API}/coins/${CHAIN_DATA.ETH.coingeckoTokenId}`);
        const ethData = await ethResponse.json();
        const ethMarketcap = ethData.market_data.market_cap.usd;
        const ethPrice = ethData.market_data.current_price.usd;
        results.market_cap = (results.price / ethPrice) * ethMarketcap;
    }
    return results;
};

export const makeMaybeFetchTokenQuotes = () => {
    const store = {};
    const isFetching = {};

    return async(token) => {
        if (isFetching[token]) return null;
        if (store[token]) return store[token];
        
        isFetching[token] = true;
        let result = {};
        try {
            result = await fetchTokenQuotes(token);
            store[token] = result;
        } catch (error) {
            console.log('QA: error', { error });
        }
        
        isFetching[token] = false;
        return result;
    }
}